import MyCoinsBadge from 'components/bottomsheet/components/MyCoinsBadge';
import { Button } from 'components/common';
import useBottomSheet from 'hooks/common/useBottomSheet';
import { useEffect, useMemo } from 'react';
import { NeedCoinData } from 'types/bottomsheet';
import ProductItem from './components/ProductItem';

const NeedCoinContent = () => {
  const { sheets, closeWithAnimation } = useBottomSheet();
  const sheet = sheets.NeedCoin;
  const {
    productIds,
    premiumProductId,
    showShopBtn = true,
    bonusRatio = 0,
    title = brsc.low_coins_title,
    body = brsc.sheet_low_coins_swipecall,
    header,
    premiumCaption,
    promo,
    membership = false,
    coins,
    keepPromo = false,
  } = sheet.data as NeedCoinData;

  const products = useMemo(() => (productIds ?? []).map((productId) => ({ ...PageShop.getProductDetails(productId), productId })), [productIds]);

  useEffect(() => {
    PurchaseManager.attach((err, coin, productId) => {
      if (err) {
        return;
      }

      BLog.log('[NeedCoin] coin purchased', productId);
      closeWithAnimation(sheet.id, { data: { productId, coin } });
    });
  }, [closeWithAnimation, sheet.id]);

  useEffect(() => {
    return () => {
      PurchaseManager.detach();
      // 첫 결제 프로모션처럼 시트 밖에서 켠 프로모션은 지우지 않는다
      if (!keepPromo) PageShop.resetPromo();
    };
  }, [keepPromo]);

  // 코인샵 이동은 호출부가 한다 (이동 후 구매 로그를 남기기 위해)
  const goToShop = () => closeWithAnimation(sheet.id, { data: { shop: true } });

  const buyCoin = (productId: string) => {
    if (bonusRatio > 0) {
      Braze.applyPageShopProtocol(new URL(`thebermuda://deeplink/promo?bonus_ratio=${bonusRatio}`));
    }

    PurchaseManager.buyCoin(productId);
  };

  return (
    <div className="flex flex-col items-center justify-center">
      {coins !== undefined && <MyCoinsBadge coins={coins} />}
      {header && <div className="w-full" dangerouslySetInnerHTML={{ __html: header }} />}
      <div className="typography-headline-md text-center">{title}</div>
      <div className="typography-headline-sm text-center text-base-txt-secondary" dangerouslySetInnerHTML={{ __html: body }} />
      {promo && (
        // 예전 코인 부족 팝업의 첫 결제 프로모션 배너 (dialog.css)
        <div className="needcoin-promo" onClick={goToShop}>
          <div className="needcoin-promo-cont">
            <div className="needcoin-promo-title" dangerouslySetInnerHTML={{ __html: `✨${promo.title}✨` }} />
            <div className="needcoin-promo-date">{promo.until}</div>
          </div>
          <div className="w-2" />
          <div className="needcoin-promo-img">
            <img src="/imgweb/etc/promo_coin.png" alt="" />
          </div>
        </div>
      )}
      <div className="h-4" />
      {membership ? (
        // 예전 닉네임 변경 코인 부족 팝업의 멤버십 안내 (dialog.css)
        <div className="membership-box text-center" onClick={() => closeWithAnimation(sheet.id, { data: { membership: true } })}>
          <div className="membership-cont">
            <img className="membership-img" src="/imgweb/etc/membership.png" alt="" />
            <div className="membership-desc">
              {brsc.coin_popup_name6}
              <div className="membership-enter-btn flexcenter">
                <div className="membership-enter-btn-cont">{brsc.coin_popup_name7}</div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="align-center flex w-full gap-2 py-4">
          {products.map((product) => (
            <div key={product.productId} className="flex flex-1 flex-col gap-2">
              {premiumCaption && (
                <div className="needcoin-able flexcenter" style={{ visibility: product.productId === premiumProductId ? 'visible' : 'hidden' }}>
                  <div className="needcoin-able-cont">{premiumCaption}</div>
                </div>
              )}
              <ProductItem
                item={product}
                onClick={() => buyCoin(product.productId)}
                promoType={product.productId === premiumProductId ? 'best' : null}
                bonusRatio={bonusRatio}
              />
            </div>
          ))}
        </div>
      )}
      <div className="mt-2 flex w-full justify-center gap-3">
        {showShopBtn && (
          <Button onClick={goToShop} className="flex-1" style={{ text: brsc.go_to_shop, color: 'btn-bg-primary', fontColor: 'btn-txt-primary', borderRadius: 'lg' }} />
        )}
        {!showShopBtn && (
          <Button
            onClick={() => closeWithAnimation(sheet.id)}
            className="flex-1 px-4"
            style={{ text: brsc.cancel, color: 'btn-bg-normal', fontColor: 'btn-txt-normal', borderRadius: 'lg' }}
          />
        )}
      </div>
    </div>
  );
};

export default NeedCoinContent;
